import React from 'react'
import Link from 'gatsby-link'

const Contact = () => (
  <div>
    <h1>Hi from the second page</h1>
    <p>Welcome to page 2</p>
    <Link to="/">Go back to the homepage</Link>
  </div>
)

export default Contact;



// WEBPACK FOOTER //
// ./src/pages/contact.js